module.exports = __webpack_public_path__ + "img/instance_logo_login.34d413b5.png";